// Mirrors ADMIN_FEATURE_FLAG_SECTIONS in equalution-backend
// (src/modules/global_config/adminFeatureFlags.ts) - keep the two in sync.
export const ADMIN_FEATURE_FLAG_SECTIONS = {
  nav: ['filters', 'clients', 'data', 'tools', 'adminTools', 'approvals'],
  filters: [
    'newClients',
    'clientsWithAddOns',
    'checkInToday',
    'preApprovedMealPlan',
    'internationalClients',
    'taggedClients',
    'allFilters',
  ],
  data: [
    'brandedIngredients',
    'genericIngredients',
    'customIngredients',
    'meals',
    'dietaryExclusions',
    'highlightedMeals',
    'foodTags',
    'foodTagsCategory',
    'mealTags',
  ],
  tools: ['initialStrategy', 'waterIntakeGoal', 'administrativeAudit'],
  adminTools: [
    'checkinAnalytics',
    'productPurchases',
    'appleInAppPurchases',
    'mealPlanApprovals',
    'products',
    'globalConfigurations',
    'aiCoachBetaAccess',
    'aiCoachFeedback',
  ],
  approvals: ['linkBrandedIngredients', 'alternativeIngredients'],
  clientsList: ['adminsTab'],
  clientDetail: [
    'profile',
    'body',
    'taste',
    'foodDiary',
    'checkIn',
    'intakeGoal',
    'mealPlans',
    'logs',
    'products',
    'admin',
  ],
  clientDetailAdmin: [
    'subscription',
    'cancellationRequest',
    'deleteAccount',
    'resetPassword',
  ],
  checkinAnalyticsPage: ['checkinDistribution', 'statuses'],
};

export const DEFAULT_ADMIN_FEATURE_FLAGS = Object.fromEntries(
  Object.keys(ADMIN_FEATURE_FLAG_SECTIONS).map((section) => [
    section,
    Object.fromEntries(
      ADMIN_FEATURE_FLAG_SECTIONS[section].map((key) => [key, true])
    ),
  ])
);

// Fails open: an unrecognised section/key or a config that hasn't loaded yet
// must never hide a feature that should be visible.
export function isFeatureEnabled(flags, section, key) {
  return flags?.[section]?.[key] !== false;
}
